import React from 'react'

export default function Footer() {
  const currentYear = 2026

  return (
    <footer className="bg-[#060c08] border-t border-[#14281b] text-neutral-400">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-8 sm:gap-12">
          {/* Identity & Legal Entity */}
          <div className="lg:col-span-5 space-y-4">
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 rounded-lg bg-[#112417] border border-emerald-500/30 flex items-center justify-center text-white font-bold text-xs tracking-wider">
                BFT
              </div>
              <div className="flex flex-col">
                <span className="text-base font-bold text-white tracking-tight">
                  Biofuel Technology Global
                </span>
                <span className="text-xs text-emerald-400/90 font-medium">
                  BFT Global
                </span>
              </div>
            </div>

            <p className="text-xs sm:text-sm text-neutral-400 leading-relaxed max-w-sm">
              Advanced collection, preprocessing, and processing of lignocellulosic silvicultural and agricultural biomass into biofuels, biogasses, green chemicals, and biogenic CO2.
            </p>

            <div className="pt-2 text-xs text-neutral-400">
              <span className="text-neutral-400 font-semibold uppercase tracking-wider block mb-1">
                Parent Company
              </span>
              <span className="font-semibold text-neutral-200">TAB HOLDING ApS</span>
            </div>
          </div>

          {/* Location & Address */}
          <div className="lg:col-span-4 space-y-3">
            <span className="text-xs font-semibold uppercase tracking-wider text-emerald-400">
              Headquarters
            </span>
            <address className="not-italic text-xs sm:text-sm text-neutral-300 space-y-1 leading-relaxed">
              <div className="font-semibold text-white">Biofuel Technology Global</div>
              <div>Bredkaer Parkvej 58</div>
              <div>8250 Egaa, Denmark</div>
            </address>

            <div className="pt-2 flex flex-col space-y-1.5 text-xs">
              <span className="text-neutral-400 font-semibold uppercase tracking-wider">
                Direct Contact
              </span>
              <a
                href="mailto:tab@biofuelglobal.dk"
                className="text-neutral-300 hover:text-emerald-400 transition-colors whitespace-nowrap"
              >
                tab@biofuelglobal.dk
              </a>
              <a
                href="mailto:pta@biofuelglobal.dk"
                className="text-neutral-300 hover:text-emerald-400 transition-colors whitespace-nowrap"
              >
                pta@biofuelglobal.dk
              </a>
            </div>
          </div>

          {/* Partner Reference */}
          <div className="lg:col-span-3 space-y-3">
            <span className="text-xs font-semibold uppercase tracking-wider text-emerald-400">
              Partner Organization
            </span>
            <div className="space-y-1.5 text-xs sm:text-sm">
              <div className="font-semibold text-white">Kinetic Biofuel</div>
              <a
                href="https://www.kineticbiofuel.com"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1.5 text-emerald-400 hover:text-emerald-300 font-medium transition-colors whitespace-nowrap"
              >
                <span>www.kineticbiofuel.com</span>
                <i className="fa-solid fa-arrow-up-right-from-square text-[10px]" aria-hidden="true" />
              </a>
              <div className="pt-1">
                <a
                  href="mailto:tab@kineticbiofuel.com"
                  className="text-neutral-300 hover:text-emerald-400 transition-colors whitespace-nowrap"
                >
                  tab@kineticbiofuel.com
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-[#122419] flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-neutral-400">
          <div>
            © {currentYear} Biofuel Technology Global · TAB HOLDING ApS. All rights reserved.
          </div>
          <div className="text-neutral-400 flex items-center gap-2">
            <span className="w-1.5 h-1.5 rounded-full bg-emerald-500" aria-hidden="true" />
            <span>Interim Presentation Platform</span>
          </div>
        </div>
      </div>
    </footer>
  )
}
